module.exports = __webpack_public_path__ + "static/media/img69.9e21839e.png";